<template>
    <div class="owners-representative-invite page-invite">
        <data-form title="Invite Owners Representative"
                   tag="owners-representative-invite"
                   save-button-label="Send"
                   :field-model="fieldModel"
                   :field-groups="fieldGroups"
                   :on-submit-handler="onSubmit"
                   submit-success-message="Invite sent"
                   submit-error-message="Error inviting user"
                   :submit-success-route="'/'">
        </data-form>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import Agency from '@/models/Agency'

export default {
    name: 'OwnersRepresentativeInvite',
    data () {
        return {
            fieldModel: {
                fields: {
                    email: {
                        label: 'Email',
                        type: 'text'
                    },
                }
            },
            fieldGroups: [['email']],
        }
    },
    methods: {
        onSubmit (modelInstance) {
            return this.$api.inviteOwnersRepresentative(this, modelInstance)
        }
    }
}
</script>
